import { render, staticRenderFns } from "./FollowingUpNote.vue?vue&type=template&id=310f8140&"
import script from "./FollowingUpNote.vue?vue&type=script&lang=js&"
export * from "./FollowingUpNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports